module.exports = __webpack_public_path__ + "img/86.6dc19dbb.jpg";